<label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
<p-inputMask
  class="{{
    formControl.invalid && formControl.touched ? 'p-invalid' : ''
  }} p-filled"
  [id]="field.id"
  mask="#?******"
  slotChar="#______"
  characterPattern="[A-Fa-f]"
  [formControl]="formControl"
></p-inputMask>
<p-colorPicker
  [formControl]="formControl"
  [id]="field.id"
  appendTo="body"
  format="hex"
></p-colorPicker>
